import { extendTheme } from '@chakra-ui/react'

const theme = extendTheme({
    styles: {
        global: {
            body: {
                bg: 'rgb(232, 243, 241)',
            },
        },
    }
})

export default theme